import { InputPatterns } from './input-patterns.constant';
import { AbstractControl, FormArray, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { StringHelper } from '../../core/helpers/strings.helper';

export class CustomFormControl {
	// tslint:disable-next-line:variable-name
	private _controlDef: CustomFormControlDefinition = new CustomFormControlDefinition();

	private get validators() {
		const validators: Array<any> = [];
		if (this._controlDef.required) {
			validators.push(Validators.required);
		}
		if (this._controlDef.maxLength) {
			validators.push(Validators.maxLength(this._controlDef.maxLength));
		}
		if (this._controlDef.minLength) {
			validators.push(Validators.minLength(this._controlDef.minLength));
		}
		if (this._controlDef.minValue) {
			validators.push(Validators.min(this._controlDef.minValue));
		}
		if (this._controlDef.maxValue) {
			validators.push(Validators.max(this._controlDef.maxValue));
		}
		if (this._controlDef.pattern) {
			validators.push(Validators.pattern(this._controlDef.pattern));
		}
		if (this._controlDef.type === 'email') {
			validators.push(Validators.email);
		}
		if (this._controlDef.isFormArray) {
			validators.push(Validators.min(1));
		}
		if (this._controlDef.isEmail) {
			validators.push(Validators.email);
		}
		if (this._controlDef.isNumber) {
			validators.push(this.numberValidation)
		}
		if (this._controlDef.isPin) {
			validators.push(this.pinValidation);
		}
		if (this._controlDef.isPassword) {
			validators.push(this.passwordValidation);
		}
		if (this._controlDef.isUsername) {
			validators.push(this.usernameValidation);
		}
		if (this._controlDef.isBVN) {
			validators.push(this.bvnValidation);
		}
		if (this._controlDef.isNin) {
			validators.push(this.ninValidation);
		}
		if (this._controlDef.imposePasswordStrength) {
			validators.push(...[
				Validators.minLength(8),
				Validators.pattern(InputPatterns.PASSWORD)]);
		}
		if (this._controlDef.imposeNameFieldValidation) {
			validators.push(...[
				Validators.pattern(InputPatterns.NAME_FIELD)]);
		}
		if (this._controlDef.imposeUsernamePolicy) {
			validators.push(...[
				Validators.pattern(InputPatterns.USERNAME_POLICY)]);
		}
		return Validators.compose(validators);
	}

	usernameValidation(control: AbstractControl): { [key: string]: any } | null {
		const username = control.value;
		const isValid = StringHelper.isValidUsername(username);
		if (isValid) {
			return null;
		} else {
			return { username: true };
		}
	}

	pinValidation(control: AbstractControl): { [key: string]: any } | null {
		const pin = control.value;
		const isValid = StringHelper.validPin(pin);
		if (isValid) {
			return null;
		} else {
			return { pin: true };
		}
	}

	numberValidation(control: AbstractControl): { [key: string]: any } | null {
		const number = control.value;
		const isValid = StringHelper.validNumber(number);
		if (isValid) {
			return null;
		} else {
			return { number: true };
		}
	}

	passwordValidation(control: AbstractControl): { [key: string]: any } | null {
		const password = control.value;
		const isValid = StringHelper.validSecret(password);
		if (isValid) {
			return null;
		} else {
			return { password: true };
		}
	}

	ninValidation(control: AbstractControl): { [key: string]: any } | null {
		const nin = control.value;
		const isValid = StringHelper.validNIN(nin);
		if (isValid) {
			return null;
		} else {
			return { nin: true };
		}
	}
	bvnValidation(control: AbstractControl): { [key: string]: any } | null {
		const bvn = control.value;
		const isValid = StringHelper.validBVN(bvn);
		if (isValid) {
			return null;
		} else {
			return { bvn: true };
		}
	}

	public id(id) {
		this._controlDef.id = id;
		return this;
	}

	public placeholder(placeholder) {
		this._controlDef.placeholder = placeholder;
		return this;
	}

	public name(name) {
		this._controlDef.name = name;
		return this;
	}

	public type(type) {
		this._controlDef.type = type;
		return this;
	}

	public isRequired(required = true) {
		this._controlDef.required = required;
		return this;
	}

	public maxLength(length) {

		this._controlDef.maxLength = length;
		return this;
	}

	public minLength(length) {
		this._controlDef.minLength = length;
		return this;
	}


	public minValue(val) {

		this._controlDef.minValue = val;
		return this;
	}

	public maxValue(val) {
		this._controlDef.maxValue = val;
		return this;
	}

	public pattern(val) {
		this._controlDef.pattern = val;
		return this;
	}

	public isCurrencyAmount() {
		this._controlDef.isCurrencyAmount = true;
		return this;
	}

	public isAccountNumber() {
		this._controlDef.isAccountNumber = true;
		return this;
	}

	public isPhoneNumber() {
		this._controlDef.isPhoneNumber = true;
		return this;
	}

	public isName() {
		this._controlDef.isName = true;
		return this;
	}

	public isAlphaNumeric() {
		this._controlDef.isAlphaNumeric = true;
		return this;
	}

	public isOTP() {
		this._controlDef.isOTP = true;
		return this;
	}

	public isBVN() {
		this._controlDef.isBVN = true;
		return this;
	}

	public isNIN() {
		this._controlDef.isNin = true;
		return this;
	}


	public isEmail() {
		this._controlDef.isEmail = true;
		return this;
	}

	public isPin() {
		this._controlDef.isPin = true;
		return this;
	}

	public isNumber() {
		this._controlDef.isNumber = true;
		return this;
	}

	public isUsername() {
		this._controlDef.isUsername = true;
		return this;
	}

	public isPassword() {
		this._controlDef.isPassword = true;
		return this;
	}

	public imposePasswordStrength() {
		this._controlDef.imposePasswordStrength = true;
		return this;
	}

	public imposeNameFieldValidation() {
		this._controlDef.imposeNameFieldValidation = true;
		return this;
	}

	public imposeUsernamePolicy() {
		this._controlDef.imposeUsernamePolicy = true;
		return this;
	}

	public allowChanges(val) {
		this._controlDef.allowChanges = val;
		return this;
	}

	public showError(val) {
		this._controlDef.showError = val;
		return this;
	}

	public showIcon(val) {
		this._controlDef.showIcon = val;
		return this;
	}

	public showAction(val) {
		this._controlDef.showAction = val;
		return this;
	}

	public isLoading(val) {
		this._controlDef.submitting = val;
		return this;
	}

	public build(): CustomFormControlDefinition {
		this._controlDef.formGroupControl = new FormControl(
			'',
			this.validators
		);
		return this._controlDef;
	}

	public buildFormArray(controls): CustomFormControlDefinition {
		this._controlDef.formGroupArray = new FormArray(controls);
		return this._controlDef;
	}
}

export class CustomFormControlDefinition {
	public id = '';
	public placeholder = '';
	public name = '';
	public type = 'text';
	public maxLength;
	public minLength;
	public pattern: RegExp;
	public minValue: number;
	public maxValue: number;
	public required = false;
	public isCurrencyAmount = false;
	public currency = '₦';
	public isAccountNumber = false;
	public isPhoneNumber = false;
	public isAlphaNumeric = false;
	public isBVN = false;
	public isPin = false;
	public isPassword = false;
	public isNumber = false;
	public isName = false;
	public isUsername = false;
	public isEmail = false;
	public isOTP = false;
	public allowChanges = true;
	public imposePasswordStrength = false;
	public imposeNameFieldValidation = false;
	public imposeUsernamePolicy = false;
	public showIcon = false;
	public showAction = false;
	public submitting = false;
	public formGroupControl: FormControl;
	public formGroupArray: FormArray;
	public isFormArray = false;
	public isDatePicker: boolean;
	public showError = true;
	public isNin = false;

	public setCurrency(currency) {
		if (currency) {
			this.currency = currency === 'NGN' ? '₦' : currency === 'USD' ? '$' : currency === 'GBP' ? '£' : currency;
		}
	}
}

export function arrayNotEmptyValidator(): ValidatorFn {
	return (formArray: AbstractControl): ValidationErrors | null => {
		const arrayControl = formArray as FormArray;
		return arrayControl.length > 0 ? null : { arrayNotEmpty: true };
	};
}

export function minLessThanMaxValidator(): ValidatorFn {
	return (formGroup: AbstractControl): ValidationErrors | null => {
		const minLength = formGroup.get('MIN_CHAR_LENGTH')?.value;
		const maxLength = formGroup.get('MAX_CHAR_LENGTH')?.value;
		if (minLength !== null && maxLength !== null && minLength > maxLength) {
			return { minGreaterThanMax: true };
		}

		return null;
	};
}

export function minNumberLessThanMaxNumberValidator(): ValidatorFn {
	return (formGroup: AbstractControl): ValidationErrors | null => {
		const minNumber = formGroup.get('MIN_NUMBER')?.value;
		const maxNumber = formGroup.get('MAX_NUMBER')?.value;

		if (minNumber !== null && maxNumber !== null && minNumber > maxNumber) {
			return { minNumberGreaterThanMaxNumber: true };
		}

		return null;
	};
}

export function validateIntegerOrGivenDecimalFloat ( decimals = 1) {
	return (control: AbstractControl)  => {
		const regex = new RegExp(`^(\\d+)?(\\.(\\d{1,${decimals}})?)?$`);
		const number = control.value;
		const isValid = regex.test(number);

		if (isValid) {
			return null;
		} else {
			return { integerOrGivenDecimalFloat: true };
		}
	}
}

export function validateStartsWithSingleZero (control: AbstractControl) {
	return control.value?.trim?.().startsWith?.('00') ? { startsWithSingleZero: true } : null;
}
